import { render } from "./Sidebar.vue?vue&type=template&id=0d60e245&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=0d60e245&lang=scss&scoped=true"

import exportComponent from "/var/www/clients/client1/web6/web/cartamovil-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d60e245"]])

export default __exports__